import React, { useState } from 'react';
import { API_BASE_URL, MODULE_TYPE } from '../../utils/constants';
import { api } from '../../utils/axios';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import Loader from '../../components/Loader';
import { handleImageUploaded } from '../../utils/helper';

const ImageUpload = ({ isOpen, toggle, onUpload, renameOriginal = true, renameOriginalRaw = true }) => {
  const [showModalLoading, setShowModalLoading] = useState(false);
  const [file, setFile] = useState();
  const [image, setImage] = useState();
  const [imageUploadError, setImageUploadError] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const filename = file.name;
      const validFilenameRegex = /^[a-zA-Z0-9-_]+$/;

      const [baseFilename, ...extensionParts] = filename.split('.');
      const extension = extensionParts.length > 0 ? '.' + extensionParts.join('.') : '';

      if (!validFilenameRegex.test(baseFilename)) {
        const updatedBaseFilename = baseFilename
          .toLowerCase()
          .replace(/[^a-zA-Z0-9-_]/g, '_')
          .replace(/^[-_]+|[-_]+$/g, '');

        const updatedFileName = updatedBaseFilename + extension;
        alert(`Invalid filename. Use this filename: ${updatedFileName}`);
        setImageUploadError(true);
        return;
      } else {
        setImageUploadError(false);
      }
      setFile(file);
      setImage(URL.createObjectURL(file));
    }
  };

  const handleUpload = () => {
    if (file) {
      setShowModalLoading(true);
      const payload = {
        isAsset: true,
        renameOriginal,
        renameOriginalRaw,
      };

      const formData = new FormData();
      formData.append('file', file);

      api({
        method: 'POST',
        url: `${API_BASE_URL}/attachment/upload?config=${btoa(JSON.stringify(payload))}`,
        data: formData,
      })
        .then(async (filePreview) => {
          const file = await handleImageUploaded(filePreview, 'acceptFile', MODULE_TYPE.TPZ_APP, false);
          onUpload(file);
          toggle();
        })
        .catch((err) => {
          console.warn('Error uploading file:', err);
        })
        .finally(() => {
          setShowModalLoading(false);
        });
    }
  };

  return (
    <>
      <Loader isActive={showModalLoading} />
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>Upload Image</ModalHeader>
        <ModalBody className="p-4">
          <input type="file" value={file?.filename} onChange={handleFileChange} />
          {image && (
            <div className="image-preview position-relative me-2 mt-4 border border-secondary rounded-3 p-4">
              <div className="text-center">
                <img
                  src={image}
                  alt="Selected"
                  className="img-fluid rounded"
                  style={{ maxWidth: '300px', maxHeight: '300px' }}
                />
              </div>
              <button
                type="button"
                className="btn btn-danger w-100 mt-3"
                onClick={() => {
                  setImage(null);
                  setFile({ filename: '' });
                }}>
                <i className="bx bx-trash me-2" />
                Remove
              </button>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleUpload} disabled={!file || imageUploadError}>
            Upload
          </Button>
          <Button color="light" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ImageUpload;
